<template>
  <div class="user-content">
    <div class="container">
      <div class="my-auto w-100 main-area">
        <PrintProfile />
      </div><!-- ends main-area -->
    </div>
  </div>
</template>

<script>
import PrintProfile from '@/components/dashboard/applicants/profile/PrintProfile.vue';

export default {
  name: 'PrintApplicantProfile',
  components: { PrintProfile },
  mounted() {
    this.changeBodyBackground();
  },
};
</script>

<style scoped>

</style>
